module.exports = __webpack_public_path__ + "img/growth-2.82efde63.svg";